<template>
  <v-container class="py-10" id="herausforderungenUebersicht">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#005a85">Herausforderungen</div>
        <h2>Herausforderungen Übersicht</h2>
        <p>
          Die Digitalisierung wird nicht nur im sozialen Sektor als
          Herausforderung gesehen. <b>Jede zweite</b> befragte Organisation gibt
          an, dass die Digitalisierung im Allgemeinen eine große oder sehr große
          Herausforderung für sie darstellt. <br />
          Im Konkreten werden vor allem das Aufbringen von erforderlichen
          Ressourcen (<b>59%</b>) und das Einhalten von einzelnen Gesetzen wie
          zum Beispiel der DSGVO (<b>66%</b>) genannt.
        </p>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{ name: 'methodology' }"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span>Stichprobe &amp; Methoden</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{
                name: 'comparison',
                query: { var: 'konkrete Herausforderungen' }
              }"
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Zum Analyse-Tool</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Herausforderungen",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: "Digitalisierung als Herausforderung"
        },
        xAxis: {
          categories: [
            "Digitalisierung allgemein",
            "",
            "Mitarbeiteransprüche an ihren Arbeitsplatz",
            "Zugang zu digitaler Infrastruktur",
            "Kompetenz zur Nutzung digitaler Tools",
            "Nicht absehbare Risiken der Digitalisierung",
            "Zunahme der relevanten Kommunikationskanäle",
            "Aufbringen der erforderlichen Ressourcen",
            "Einhalten einzelner Gesetze (z.B. DSGVO)"
          ],
          labels: {
            align: "left",
            reserveSpace: true
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        legend: {
          enabled: true,
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: "percent",
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        //colors: ["#9d0c4a", "#ad4594", "#e353aa"],
        series: [
          {
            name: "Große Herausforderung",
            data: [50.7, null, 28.1, 31.0, 46.3, 50.0, 51.6, 59.2, 65.5]
          },
          {
            name: "Mittlere Herausforderung",
            data: [25.4, null, 22.5, 21.7, 21.0, 26.1, 24.6, 20.0, 17.9]
          },
          {
            name: "Geringe Herausforderung",
            data: [23.9, null, 49.4, 47.3, 32.8, 23.9, 23.8, 20.7, 16.6]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Herausforderungen",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
